const LayOut = ({ children }) => {
  return (
    <>
      <div className="mt-[5rem]">{children}</div>
    </>
  );
};

export default LayOut;
